module.exports = __webpack_public_path__ + "static/media/turbonomic.02442508.png";